import { styled } from 'styled-components';
import { colors, getFontSize, getFontWeight } from '../../../../abstracts';
import { dontForwardProps } from '../../../../util';
export const a11yBreakpoint = 'max-height: 16em';
export const ModalHeader = styled.header.withConfig({
  componentId: "aui__sc-djucqc-0"
})(["height:auto;flex-shrink:0;margin-right:2.5rem;"]);
export const ModalScrollContainer = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-djucqc-1"
})(["flex-direction:column;display:", ";overflow-y:", ";margin-bottom:1rem;@media only screen and (", "){display:initial;overflow-y:auto;}"], ({
  stickyHeader
}) => stickyHeader ? 'flex' : 'initial', ({
  stickyHeader
}) => stickyHeader ? 'hidden' : 'auto', a11yBreakpoint);
export const ModalTitle = styled.h2.withConfig({
  componentId: "aui__sc-djucqc-2"
})(["margin:0;word-break:break-word;font-size:", ";font-weight:", ";"], ({
  fontSize
}) => Number.isInteger(fontSize) ? getFontSize(fontSize) : getFontSize(5), getFontWeight('base'));
export const ModalSubTitle = styled.h3.withConfig({
  componentId: "aui__sc-djucqc-3"
})(["margin:0;font-size:", ";font-weight:", ";line-height:150%;color:", ";"], getFontSize(1), getFontWeight('base'), colors.neutralDeeper);
export const ModalMain = styled.section.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-djucqc-4"
})(["display:flex;overflow-y:", ";min-height:0;flex-direction:column;font-size:", ";font-weight:", ";line-height:150%;margin-top:1rem;"], ({
  stickyHeader
}) => stickyHeader ? 'auto' : 'hidden', getFontSize(2), getFontWeight('base'));